import { Connection } from '../../pages/outreach/models/connection.model';
import { RecordVisibilityMode } from '../enums/record-visibility';
import { UserConnection } from '../models/user';

export interface Company {
  leadId: number | undefined;
  unique_id: string;
  company_name: string;
  short_address: string;
  assigned_on_utc?: Date;
  latitude?: number;
  longitude?: number;
  assigned_to: Assignee | null;
  source: string;
  created_by_user: UserConnection | null;
  created_on_utc: Date;
  latest_submission_on_utc?: Date;
  vlf_reallocated_on_utc?: Date | null;
  assignees: AssigneeConnectionDetails[] | null;
  is_active: boolean;
  lead_status?: string;
  lead_status_updated_on_utc?: Date;
  visibility_mode?: RecordVisibilityMode;
  view_stats?: {
    user_count: number;
    org_count: number;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lead_attributes?: Record<string, any> | null;
}

export class Assignee {
  public user_id: string | undefined;
  public username: string | undefined;
  public first_name: string | undefined;
  public last_name: string | undefined;
  public group_name: string | undefined;
}

export interface AssigneeConnectionDetails extends Connection {
  assigned_on_utc: Date | undefined;
  lead_status?: number;
  cdfi_logo_path?: string | null;
  approved_loan_amount?: number;
}

export interface ContainerSasUrl {
  container_url: string;
  sas_token: string;
}
